import React from "react";

const RejectedCases: React.FC = () => {
    return (
        <div>Rejected Cases Content</div>
    );
}

export default RejectedCases;